import _ from "lodash";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { all, findFrom } from "../../../../Services/frameworkService";
import { get, update } from '../../../../Services/clientService';
import { deletefw } from "../../../../Services/clientService";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { Accordion, AccordionTab } from 'primereact/accordion';
import RadioElement from "../../../../Components/UiComponents/RadioElement";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';

export default function Programme(props) {
    useEffect(() => {
        getFrameworkData();
    }, [props.customerId]);

    useEffect(() => {
        if (props.branch) {
            cliData();
        }
    }, [props.clientId, props.branch])

    const [isModelOpen, setModelOpen] = useState(false);
    const [frameworkDetails, setFrameworkDetails] = useState({});
    const [checkedCheckboxes, setCheckedCheckboxes] = useState({});
    const [selectedFrameworks, setSelectedFrameworks] = useState([]);
    const [checkedForRemoval, setCheckedForRemoval] = useState({});
    const [currentIndex, setCurrentIndex] = useState(0);
    const [newModule, setNewModule] = useState([]);
    const [clientData, setClientData] = useState({});
    const [isSave, setIsSave] = useState(false);
    const [currentFrameworkIndex, setCurrentFrameworkIndex] = useState();
    const [loading, setLoading] = useState(false);
    const [showVideo, setShowVideo] = useState(false);

    const toastRef = useRef();

    useEffect(() => {
        if (selectedFrameworks) {
            getAllframeworks();
        }
    }, [selectedFrameworks])

    useEffect(() => {
        if (props.frameworkData?.clientSectionsFramework) {
            let obj1 = _.find(props.frameworkData?.clientSectionsFramework, { section_name: "Framework Overview" })?.display_name;
            let obj2 = _.find(props.frameworkData?.clientSectionsFramework, { section_name: "Details" })?.display_name;

            let combined = { obj1, obj2 };
            setNewModule(combined)
        }

    }, [props.frameworkData?.clientSectionsFramework])
    useEffect(() => {
        saveClient()
    }, [clientData, isSave]);

    const getAllframeworks = async () => {
        try {
            setLoading(true); // Start loading spinner

            // Fetch all frameworks
            const res = await all(props.customerId, 'analytic', 'framework_name', 1);

            setFrameworkDetails(res);

            getCurrentFrameworkIndex(res);


        } catch (error) {
            // Handle errors during the API request
            toastRef.current.showToast({
                type: "error",
                message: "Failed to load framework details. Please try again or contact Admin."
            });
        } finally {
            setLoading(false);
        }
    };

    const getFrameworkData = async () => {
        try {
            setLoading(true); // Start loading spinner

            // Attempt to fetch framework data
            const res = await findFrom(props.clientId);

            // Check if the response is valid and contains data
            if (res && res.data) {
                setSelectedFrameworks(res.data); // Set the selected frameworks
            } else {
                // Handle case where no data is returned
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to load framework data. Please try again or contact Admin.',
                });
            }
        } catch (error) {
            // Handle any errors in the API call
            toastRef.current.showToast({
                type: 'error',
                message: 'Error fetching framework data. Please try again or contact Admin.',
            });
        } finally {
            setLoading(false);
        }
    };


    const loadAssociatedProgramms = () => {
        setCheckedCheckboxes({});
        setModelOpen(true);
    }

    const closeProgrammDialog = () => {
        setModelOpen(false);
    };

    const handleCheckboxChange = (id, isChecked) => {
        setCheckedCheckboxes(prevState => {
            const newState = { ...prevState };
            if (isChecked) {
                // If checked, add or update the checkbox state
                newState[id] = {
                    checked: true,
                };
            } else {
                // If unchecked, remove the checkbox state
                delete newState[id];
            }
            return newState;
        });
    };


    const cliData = async () => {
        try {
            // Check if all required props are available
            if (props.clientId && props.customerId && props.branch) {
                setLoading(true);

                // Call the API to get the client data
                const res = await get(props.clientId, props.customerId, props.branch);

                // Extract client data and update states
                const cliData = res.data?.client?.[0];
                if (cliData) {
                    getAllframeworks(); // Call another function to get all frameworks
                    setClientData(cliData); // Set the client data state
                    props.getData(cliData); // Pass the data to a parent component or other handler
                } else {
                    toastRef.current.showToast({
                        type: "error",
                        message: "No client data found. Please try again or contact Admin."
                    });
                }
            } else {
                toastRef.current.showToast({
                    type: "error",
                    message: "Missing required data. Please ensure clientId, customerId, and branch are provided."
                });
            }
        } catch (error) {
            // Handle any API errors
            toastRef.current.showToast({
                type: "error",
                message: "Failed to fetch client data. Please try again or contact Admin."
            });
        } finally {
            setLoading(false);
        }
    };

    const saveClient = async () => {
        if (clientData && isSave) {
            var reference_data = props.customerDetails?.data?.reference_data;
            var option_choice = _.find(reference_data, { option_names: 'ClientClassificationV3' })?.option_choice
            clientData.selectedClientStatusIndex = option_choice?.findIndex(obj => obj.label === clientData.client_status)

            try {
                setLoading(true)
                const res = await update(clientData._id, clientData);
                if (res && res.data.success === true) {
                    toastRef.current.showToast({
                        type: 'success',
                        message: `${res.data.message}`
                    });
                }
                else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: `${res.data.message}`
                    });
                }
                setIsSave(false);
                getFrameworkData();
                cliData();
            } catch (error) {
                console.error(error);
            }
            try {
                setLoading(true);

                // Attempt to update the client data
                const res = await update(clientData._id, clientData);

                // Check the response and display a success or error toast notification
                if (res && res.data.success === true) {
                    toastRef.current.showToast({
                        type: 'success',
                        message: `${res.data.message}`,
                    });
                } else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: res?.data?.message || 'An error occurred while saving the client data',
                    });
                }

                // Ensure state is reset after save attempt
                setIsSave(false);

                // Trigger data refresh for framework and client data
                getFrameworkData();
                cliData();

            } catch (error) {
                // Handle any errors and show an error toast notification
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to save client data. Please try again or contact Admin.',
                });
            } finally {
                setLoading(false);
            }
        }
    };


    const handleAddSelectedFrameworks = () => {
        const selected = Object.keys(checkedCheckboxes).filter(key => checkedCheckboxes[key]);
        if (selected.length > 0) {
            const selectedFrameworksDetails = frameworkDetails?.data.filter(unit => selected.includes(unit.framework_seq.toString()));

            const existingFrameworkSeqs = new Set(selectedFrameworks.map(unit => unit.framework_seq));

            const newFrameworks = selectedFrameworksDetails.filter(unit => !existingFrameworkSeqs.has(unit.framework_seq));
            setIsSave(true)
            newFrameworks.forEach(framework => {
                let id = framework._id;
                setClientData(prevState => ({
                    ...prevState,
                    frameworks: [...prevState.frameworks, id]
                }));
            });
            setModelOpen(false);

        } else {
            setModelOpen(true);
            toastRef.current.showToast({
                type: 'error',
                message: "Atleast One " + props.frameworkData.clientFrameworkTab + " Should Be Selected"
            });
        }
    };

    const handleRemovalCheckboxChange = (id, isChecked) => {
        setCheckedForRemoval(prevState => ({
            ...prevState,
            [id]: isChecked
        }));

    };

    const removeProgram = async (data) => {
        try {
            setLoading(true);

            // Attempt to delete the framework
            const res = await deletefw(props.clientId, data._id);

            if (res && res.data.success === true) {
                toastRef.current.showToast({
                    type: 'success',
                    message: `${res.data.message}`
                });
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: res?.data?.message || 'Failed to remove the program. Please try again.'
                });
            }

            // Refresh the data after removal
            getFrameworkData();
            cliData();

        } catch (error) {
            // Catch any unexpected errors and notify the user
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred while removing the program. Please try again or contact Admin.'
            });
        } finally {
            setLoading(false);
        }
    };


    const removeAssociatedProgramms = () => {
        if (Object.keys(checkedForRemoval).length > 0) {
            const selectedForRemoval = Object.keys(checkedForRemoval).filter(key => checkedForRemoval[key]);
            var data = selectedFrameworks.filter(unit => selectedForRemoval.includes(unit.framework_seq.toString()))
            for (let d of data) {
                removeProgram(d)
            }
            setSelectedFrameworks(prevState => prevState.filter(unit => !selectedForRemoval.includes(unit.framework_seq.toString())));
            setCheckedForRemoval({});
        } else {
            toastRef.current.showToast({
                type: 'error',
                message: "Atleast One " + props.frameworkData.clientFrameworkTab + " Should Be Selected"
            });
        }

    };

    const handlePrevious = () => {
        setCurrentIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : selectedFrameworks.length - 1));
    };

    const handleNext = () => {
        setCurrentIndex(prevIndex => (prevIndex < selectedFrameworks.length - 1 ? prevIndex + 1 : 0));
    };

    useEffect(() => {
        if (currentIndex >= 0) {
            getCurrentFrameworkIndex(frameworkDetails)
        }
    }, [currentIndex])

    const getCurrentFrameworkIndex = (framework_data) => {
        const currentFramework = selectedFrameworks[currentIndex];
        setCurrentFrameworkIndex(
            framework_data?.data?.findIndex(unit => unit?.framework_seq === currentFramework?.framework_seq)
        )
    };

    const renderFooter = (a) => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement type="submit" className="save-button" onClick={handleAddSelectedFrameworks} label={_.find(props.frameworkData.clientSectionsFramework, { section_name: "Associated Frameworks" })?.section_name} />
                </div>
            </div>
        );
    }

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div className='new-field'>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="col-md-12 text-right">
				<ButtonElement className="upload-button mb-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
			</div>
            {
                _.find(props.frameworkData.clientAssociatedFrame, { table_name: "Associated Frameworks" })?.status &&
                <div className="box-border">
                    <div className="form-group row align-items-center mb-0">
                        <div className="col-md-6 pl-0">
                            <p className="label-text">
                                {_.find(props.frameworkData.clientAssociatedFrame, { table_name: "Associated Frameworks" })?.display_name}
                            </p>
                        </div>
                        <div className="col pr-0 d-flex justify-end">
                            <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={removeAssociatedProgramms} />
                            <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={loadAssociatedProgramms} />
                        </div>
                    </div>
                    <div>
                        {
                            selectedFrameworks.length > 0 && selectedFrameworks?.map((unit, index) => (
                                <div className='new-field'>
                                    <div className="form-group row align-items-center mb-0 mt-0">
                                        <div className='col pr-0 d-flex' key={unit.framework_seq}>
                                            <CheckboxElement
                                                id={unit.framework_seq}
                                                name={unit.framework_display_name}
                                                // value={unit.framework_display_name}
                                                checked={checkedForRemoval[unit.framework_seq] || false}
                                                onChangeCheck={(e) => handleRemovalCheckboxChange(unit.framework_seq, e.target.checked)}
                                                className="mr-2"
                                            />
                                            <a className="form-label-text text-left mr-20 pointer mar-l-5" onClick={(e) => setCurrentIndex(index)}>{unit.framework_display_name}</a>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            }
            {
                selectedFrameworks.length > 0 && (
                    <>
                        <div className="form-group row align-items-center mb-0 mt-20">
                            <div className="col-md-8 pl-0 pt-17">
                                <p className="sub-label-text">
                                    {selectedFrameworks[currentIndex]?.framework_display_name}
                                </p>
                            </div>
                            <div className="col pr-0 d-flex justify-end">
                                <ButtonElement className="edit-option-button" type="button" icon="pi pi-chevron-left" onClick={handlePrevious} />
                                <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-chevron-right" onClick={handleNext} />
                            </div>
                        </div>
                        {
                            !_.isEmpty(frameworkDetails) && Object.entries(newModule).map(([key, value]) => (
                                <div key={key} className='mt-10'>
                                    <Accordion activeIndex={0}>
                                        {
                                            <AccordionTab header={value} disabled>
                                                {
                                                    key == 'obj1' &&
                                                    <div className="new-field d-flex">
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsNew, { field_name: "Framework" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsNew, { field_name: "Framework" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.framework_name}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsNew, { field_name: "Framework Version Label" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsNew, { field_name: 'Framework Version Label' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.framework_label}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework Description' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework Description' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.framework_description}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "Appointment Type" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Appointment Type' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.appointment_type}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "Framework Type" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework Type' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.framework_type}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "Framework duration (years)" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework duration (years)' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.framework_type}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "Locations" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Locations' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        {frameworkDetails?.data[currentFrameworkIndex]?.summary.locations.map((location, index) => (
                                                                            <li key={index}>
                                                                                <label className="form-label text-left">{location.label}</label>
                                                                            </li>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "No. of Competitors" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'No. of Competitors' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.no_of_competitors}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "Annual Value Rational" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Annual Value Rational' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.annual_value_rational}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsNew, { field_name: "Total Framework Value" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsNew, { field_name: 'Total Framework Value' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.total_framework_value}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "Average Project Value" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Average Project Value' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.average_project_value}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.commonFields, { field_name: "Work Classification" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.commonFields, { field_name: 'Work Classification' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.work_classification}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "TUPE Transfer" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'TUPE Transfer' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.type_transfer}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: "Framework Manager" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework Manager' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary.framework_manager}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    key == 'obj2' &&
                                                    <div className="new-field d-flex">
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props.frameworkData?.commonFields, { field_name: 'Sector' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.commonFields, { field_name: 'Sector' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        {frameworkDetails?.data[currentFrameworkIndex]?.summary?.sector?.map((sector, index) => (
                                                                            <li key={index}>
                                                                                <label className="form-label text-left"> {sector.label}</label>
                                                                            </li>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'First Award' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'First Award' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="first_award"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.first_award?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary.first_award?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'No. of Projects' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'No. of Projects' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="num_projects"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.no_Of_projects?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary?.no_Of_projects?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Expected Award Date' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Expected Award Date' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="exp_award"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.expected_award_date?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary.expected_award_date?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework Start Date' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework Start Date' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="fm_start"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.framework_start_date?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary.framework_start_date?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework End Date' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Framework End Date' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="fm_end"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.framework_end_date?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary.framework_end_date?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Term period (Years)' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Term period (Years)' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="term_period"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.time_period?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary.time_period?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Predicted Annual Value' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-5 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Predicted Annual Value' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="pred_ann_value"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.predicted_annual_value?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary.predicted_annual_value?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Annual Profit Margin' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Annual Profit Margin' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="annual_profit"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.annual_profit_margin?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary.annual_profit_margin?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Value of Bid Cost Contribution' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Value of Bid Cost Contribution' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="fm_cost"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={frameworkDetails?.data[currentFrameworkIndex]?.summary?.framework_cost_contribution?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <label className="form-label text-left ml-20">{frameworkDetails?.data[currentFrameworkIndex]?.summary.framework_cost_contribution?.text}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Regions / Offices' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Regions / Offices' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        {frameworkDetails?.data[currentFrameworkIndex]?.summary?.regions_offices.map((region, index) => (
                                                                            <li key={index}>
                                                                                <label className="form-label text-left">{region.label}</label>
                                                                            </li>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.commonFields, { field_name: 'Business Unit' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.commonFields, { field_name: 'Business Unit' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        {frameworkDetails?.data[currentFrameworkIndex]?.summary?.which_business_unit.map((bu, index) => (
                                                                            <li key={index}>
                                                                                <label className="form-label text-left">{bu.label}</label>
                                                                            </li>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Target Case Studies P.A' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Target Case Studies P.A' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary?.target_case_studies_pA}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Target Testimonial P.A' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Target Testimonial P.A' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary?.target_testimonal_pA}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Target KPIs' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Target KPIs' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary?.targert_kPI}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Target RDS' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-6 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.frameworkData?.frameworkFieldsSummary, { field_name: 'Target RDS' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{frameworkDetails?.data[currentFrameworkIndex]?.summary?.target_rDS}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </AccordionTab>
                                        }
                                    </Accordion>
                                </div>
                            ))
                        }
                    </>
                )}
            <Dialog
                visible={isModelOpen}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header={_.find(props.frameworkData.clientSectionsFramework, { section_name: "Framework" })?.display_name}
                modal
                position="right"
                onHide={closeProgrammDialog}
                footer={renderFooter()}
                className="width-32"
                draggable={false}
            >
                <div className='new-field'>
                    {
                        _.find(props.frameworkData.clientFieldsFramework, { field_name: "Select Framework" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className='col pr-0'>
                                <label className="fs-16 fw-600 mar-b-3">
                                    {_.find(props.frameworkData.clientFieldsFramework, { field_name: "Select Framework" })?.display_name}
                                </label>
                                {
                                    frameworkDetails?.data?.map((unit, index) => (
                                        <div key={unit.framework_seq} className='d-flex pt-10'>
                                            <CheckboxElement
                                                id={unit.framework_seq}
                                                name={unit.framework_display_name}
                                                value={unit.framework_display_name}
                                                // checked={checkedCheckboxes[unit.framework_seq] || false}
                                                checked={selectedFrameworks.map(c => c.framework_seq).includes(unit.framework_seq)}
                                                onChangeCheck={(e) => handleCheckboxChange(unit.framework_seq, e.target.checked)}
                                                className="mr-2"
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                </div>
            </Dialog>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_STAKEHOLDERS_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="stakeholders_programme" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}